var render = function render(){var _vm=this,_c=_vm._self._c;return _c('summary-count',{attrs:{"title":"Charges this week","is-loading":_vm.isLoading,"count":_vm.charges,"change-count":-_vm.failedCount,"changeLabel":" failed this week","icon":"x"},on:{"cardClicked":function($event){return _vm.gotoLink()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }